import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { BRAND } from "@/data/mockData";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const { refresh } = useAuth();

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await login(email, password);
      await refresh();
      nav("/admin");
    } catch (e) {
      const d = e?.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="page-admin-login" className="min-h-screen bg-[#0E0E0E] text-white grid place-items-center px-6 relative overflow-hidden">
      <div aria-hidden className="absolute inset-x-0 -bottom-32 flex justify-center pointer-events-none select-none opacity-[0.05]">
        <span className="font-serif italic text-[42vw] leading-[0.75] tracking-[-0.05em]">sirija</span>
      </div>
      <div className="relative w-full max-w-md">
        <div className="flex items-center gap-3">
          <img src={BRAND.logo} alt="SIRIJA" className="h-10 w-10 rounded-full ring-1 ring-white/20" />
          <div className="font-serif text-3xl tracking-[0.14em]">SIRIJA</div>
        </div>
        <h1 className="mt-10 font-serif font-light text-5xl leading-tight">Studio admin.</h1>
        <p className="mt-3 text-white/60 text-sm">Sign in to manage products, Instagram feed, and enquiries.</p>

        <form onSubmit={submit} data-testid="admin-login-form" className="mt-10 space-y-4">
          <div>
            <label className="overline text-white/50">Email</label>
            <Input
              required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email"
              className="mt-2 h-12 rounded-lg bg-white/5 border-white/15 text-white placeholder:text-white/30 focus-visible:ring-white/40"
            />
          </div>
          <div>
            <label className="overline text-white/50">Password</label>
            <Input
              required type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password"
              className="mt-2 h-12 rounded-lg bg-white/5 border-white/15 text-white placeholder:text-white/30 focus-visible:ring-white/40"
            />
          </div>
          {err && <div data-testid="admin-login-error" className="text-sm text-red-300">{err}</div>}
          <button
            type="submit" disabled={busy}
            data-testid="admin-login-submit"
            className="w-full h-12 rounded-full bg-white text-[#1A1A1A] text-xs uppercase tracking-[0.2em] hover:bg-white/90 transition-colors disabled:opacity-60"
          >
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
